import { render, staticRenderFns } from "./CreateChecklistChooseMethodPage.vue?vue&type=template&id=e2c06b9a&"
import script from "./CreateChecklistChooseMethodPage.vue?vue&type=script&lang=ts&"
export * from "./CreateChecklistChooseMethodPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports